export const USER_LOAD_START = 'custom/user/USER_LOAD_START';
export const USER_LOADED_SUCCESS = 'custom/user/USER_LOADED_SUCCESS';
export const USER_LOAD_FROM_APP_BAR = 'custom/user/USER_LOAD_FROM_APP_BAR';

const actions = {
    USER_LOAD_START,
    USER_LOADED_SUCCESS,
    USER_LOAD_FROM_APP_BAR,
    updateUserProfile: (userData) => ({
        type: actions.USER_LOADED_SUCCESS,
        user: userData
    })
}

export default actions;